
import { MainComponent } from './Main';
export default MainComponent;
